export const AUTH_MODES = {
  /** V6 sessions that existed before the email-first migration. */
  LEGACY: 'legacy',
  /** The email-first V3 stack; every new sign-in and registration. */
  V3: 'v3',
} as const;

export type AuthMode = (typeof AUTH_MODES)[keyof typeof AUTH_MODES];

/** Where the legacy stack keeps its session; also the mode marker. */
export const LEGACY_SESSION_STORAGE_KEY = 'chauffeur-portal-session';

/**
 * Which stack owns the current visit: legacy while a V6 session record exists,
 * V3 otherwise. Read per call on purpose — a legacy sign-out removes the record,
 * and the very next request must switch to the V3 stack without a reload.
 */
export const getAuthMode = (): AuthMode =>
  window.localStorage.getItem(LEGACY_SESSION_STORAGE_KEY) === null
    ? AUTH_MODES.V3
    : AUTH_MODES.LEGACY;
